
import { Button } from '@/components/ui/button';
import { AlertTriangle, Plus } from 'lucide-react';

interface AlertSectionHeaderProps {
  type: 'absence' | 'late';
  onAddAlert: () => void;
}

export const AlertSectionHeader = ({ type, onAddAlert }: AlertSectionHeaderProps) => {
  const isAbsence = type === 'absence';
  const typeStyles = isAbsence 
    ? {
        bgColor: 'bg-destructive hover:bg-destructive/90',
        textColor: 'text-destructive',
      }
    : {
        bgColor: 'bg-warning hover:bg-warning/90',
        textColor: 'text-warning',
      };
  const title = isAbsence ? 'تنبيهات الغياب' : 'تنبيهات التأخر';
  const buttonText = isAbsence ? 'إضافة تنبيه غياب' : 'إضافة تنبيه تأخر';

  return (
    <div className="flex items-center justify-between">
      <h3 className={`font-medium text-lg ${typeStyles.textColor} flex items-center gap-2 justify-end`}>
        <AlertTriangle className="h-4 w-4" />
        <span>{title}</span>
      </h3>
      <Button
        onClick={onAddAlert}
        size="sm"
        className={`${typeStyles.bgColor} text-white`}
      >
        <Plus className="h-4 w-4 ml-1" />
        {buttonText}
      </Button>
    </div>
  );
};
